/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Send_InvitesInputs */

const cs_ebr_send_invites = /** @type {(inputs: Ebr_Send_InvitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslat pozvánku e-mailem nově vytvořeným makléřům`)
};

const en_ebr_send_invites = /** @type {(inputs: Ebr_Send_InvitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail an invite to newly created brokers`)
};

/**
* | output |
* | --- |
* | "E-mail an invite to newly created brokers" |
*
* @param {Ebr_Send_InvitesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_send_invites = /** @type {((inputs?: Ebr_Send_InvitesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Send_InvitesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_send_invites(inputs)
	return cs_ebr_send_invites(inputs)
});